import { toQuery } from '@debbie/common/dist/util/index.js';
import { collectionEngineV1, drainPages } from '../apis.js';
const hooksAPI = collectionEngineV1('/webhooks');
const PAGE_SIZE = 500;
export const create = (newHook) => hooksAPI('POST', `/`, {
    body: newHook,
});
// Pages to the end so callers keep getting the full set. creditorId narrows
// it to the hooks pinned to that creditor.
export const getAll = (creditorId) => drainPages((page) => hooksAPI('GET', `/?${toQuery({ creditorId, page, pageSize: PAGE_SIZE })}`), PAGE_SIZE);
export const get = (id) => hooksAPI('GET', `/${id}`);
export const getItems = (creditorId, query, quantity, from) => hooksAPI('GET', `/items?${toQuery({
    creditorId,
    pageSize: quantity,
    page: from,
    ...query,
})}`);
export const executeHookItem = (id) => hooksAPI('POST', `/items/execute/${id}`);
export const getItem = (id) => hooksAPI('GET', `/items/${id}`);
export const del = (id) => hooksAPI('DELETE', `/${id}`);
//# sourceMappingURL=hooks.js.map